import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../../Components/Form";
import {
    IAlteracoesProdutoDTO,
    ICadastroEmpreendimentoDTO,
    IEmpreendimento,
    IUnidadeEmpDTO,
} from "../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import {
    AtualizarProdutoController,
    CadastrarProdutoController,
    getEmpreendimentoVendasController,
    ListarRegiaoController,
    ListarSegmentoController,
    ListarSituacaoComercialController,
    ListarSituacaoObraController,
    ListarTipoIncorporacaoController,
} from "../../../../../Controllers/Geral/Produtos/ProdutosControllers";
import { ChangeEvent, DragEvent, useRef, useState } from "react";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { BuscaCEP } from "../../../../../Services/Tools/ViaCep";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import moment from "moment";
import {
    InserirDocumentosPorProdutoController,
    ListarDocumentosProdutoController,
    RemoverDocumentosPorProdutoController,
} from "../../../../../Controllers/Geral/Documentos/DocumentoProduto/DocumentoProdutoControllers";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import { Switch } from "antd";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import {
    faBuilding,
    faDatabase,
    faEdit,
    faExchangeAlt,
    faEye,
    faFile,
    faGlobe,
    faKey,
    faListAlt,
    faMap,
    faMapMarkerAlt,
    faMoneyBill,
    faSave,
    faSpa,
    faTrash,
    faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
    IDocumentoProduto,
    IInserirDocumentoProduto,
} from "../../../../../Interfaces/Geral/Documentos/DocumentoProduto/DocumentoProdutoInterfaces";
import { ListarJornadaEtapaController } from "../../../../../Controllers/Geral/GestaoDeCadastros/JornadaEtapa/JornadaEtapaController";
import { ListarTipoDocumentoController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import { formatterCPF_CNPJ } from "../../../../../Validations/InputMasks";
import { faItunes, faUnity } from "@fortawesome/free-brands-svg-icons";
import Table from "../../../../../Components/Table";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { useParams } from "react-router-dom";
import "./styles.css";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import {
    DeletarFinanciamentoProdutoVendasController,
    ListarFinanciamentoProdutoVendasController,
} from "../../../../../Controllers/Vendas/Produtos/ProdutosController";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import AdicionarEditarFinanciamento from "./AdicionarEditarFinanciamento";
interface IParams {
    idProduto?: string;
}

interface IDocumentoComIcone extends IDocumentoProduto {
    icon_url?: string;
}

interface ITabsCadastroEEditaProduto {
    row?: IEmpreendimento;
    editando?: boolean;
    updateList: () => void;
}

export default function TabsCadastroEEditaProduto(
    props: ITabsCadastroEEditaProduto
) {
    const FormMethods = useForm();

    const params = useParams<IParams>();

    const fileInputRef = useRef<any>(null);
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const [documents, setDocuments] = useState<IInserirDocumentoProduto[]>([]);
    const [pageUnidadesEmp, setPageUnidadesEmp] = useState(1);
    const [pageAlteracoes, setPageAlteracoes] = useState(1);
    const [pageDocumentosEmp, setPageDocumentosEmp] = useState(1);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDragging, setIsDragging] = useState(false);
    const [completedUploads, setCompletedUploads] = useState(0);
    const [descricaoDocs, setDescricaoDocs] = useState<
        Array<{
            ID_DOCUMENTO_PRODUTO?: number;
            DS_DOCUMENTO_PRODUTO: string;
        }>
    >([]);

    const { execute: listarJornadaEtapa } = useAsyncCallback(
        () => ListarJornadaEtapaController(true),
        []
    );

    const {
        execute: InserirDocumentosPorProduto,
        loading: InserirDocumentosPorProdutoLoading,
    } = useAsyncCallback(InserirDocumentosPorProdutoController);

    const {
        execute: RemoverDocumentosPorProduto,
        loading: RemoverDocumentosPorProdutoLoading,
    } = useAsyncCallback(RemoverDocumentosPorProdutoController);

    const { execute: buscarCEP, loading: buscarCEPLoading } =
        useAsyncCallback(BuscaCEP);

    const { execute: cadastrarProduto, loading: cadastrarLoading } =
        useAsyncCallback(CadastrarProdutoController);

    const { execute: atualizarProduto, loading: atualizarProdutoLoading } =
        useAsyncCallback(AtualizarProdutoController);

    const {
        execute: deletarFinanciamentoProduto,
        loading: deletarFinanciamentoProdutoLoading,
    } = useAsyncCallback(DeletarFinanciamentoProdutoVendasController);

    const { value: lstTipoDocs } = useAsyncEffect(
        () => ListarTipoDocumentoController(),
        []
    );

    const {
        value: emp,
        loading: empLoading,
        execute: updateListEmp,
    } = useAsyncEffect(async () => {
        if (props.row?.ID_EMPREENDIMENTO || params.idProduto) {
            const res = await getEmpreendimentoVendasController(
                props.row?.ID_EMPREENDIMENTO ?? (Number(params.idProduto) || 0)
            );
            setCep(res?.LOCALIZACAO?.DS_CEP ?? "");
            setCepSPE(res?.DADOS_SPE?.DS_CEP_SPE ?? "");
            return res;
        }
    }, [props.row?.ID_EMPREENDIMENTO, params.idProduto]);

    const {
        value: lstFinanciamento,
        loading: lstFinanciamentoLoading,
        execute: updateListFinanciamento,
    } = useAsyncEffect(async () => {
        if (props.row?.ID_EMPREENDIMENTO) {
            const res = await ListarFinanciamentoProdutoVendasController(
                props.row?.ID_EMPREENDIMENTO ?? 0
            );
            return res;
        }
    }, [props.row?.ID_EMPREENDIMENTO]);

    const {
        value: lstDocumentos,
        loading: lstDocumentosLoading,
        execute: updateListDocumentos,
    } = useAsyncEffect(async () => {
        if (props.row?.ID_EMPREENDIMENTO)
            return ListarDocumentosProdutoController(
                props.row?.ID_EMPREENDIMENTO ?? 0
            );
    }, [props.row?.ID_EMPREENDIMENTO]);

    const [cep, setCep] = useState(emp?.LOCALIZACAO?.DS_CEP ?? "");
    const [cepSPE, setCepSPE] = useState(emp?.DADOS_SPE?.DS_CEP_SPE ?? "");

    function handleCadastrarOuEditarProduto(
        formData: ICadastroEmpreendimentoDTO
    ) {
        if (!props.editando) {
            cadastrarProduto({
                ...formData,
                ID_CLASSIFICACAO_PRODUTO: 1,
                DT_AGI: formData.DT_AGI,
                DT_RECEBIMENTO_AREA_COMUM: formData.DT_RECEBIMENTO_AREA_COMUM,
                NR_TORRES: formData.NR_TORRES,
                NR_UNIDADES_TORRE: formData.NR_UNIDADES_TORRE,
                DS_TIPO_VAGA: formData.DS_TIPO_VAGA,
                DS_MURO: formData.DS_MURO,
                NR_ANDAMENTO_OBRA: formData.NR_ANDAMENTO_OBRA,
                DS_OPCAO_PLANTA: formData.DS_OPCAO_PLANTA,
                DS_FICHA_TECNICA: formData.DS_FICHA_TECNICA,
                DS_MATRICULA_IMOVEL: formData.DS_MATRICULA_IMOVEL,
                DS_PRODUTO: formData.DS_PRODUTO,
                DT_HABITESE: formData.DT_HABITESE,
                DT_INICIO_GARANTIA: formData.DT_INICIO_GARANTIA,
                DT_LANCAMENTO: formData.DT_LANCAMENTO,
                DT_PATRIMONIO_AFETACAO: formData.DT_PATRIMONIO_AFETACAO,
                DT_PREVISAO_CONCLUSAO: formData.DT_PREVISAO_CONCLUSAO,
                NR_ANDARES: formData.NR_ANDARES,
                DT_RAI: formData.DT_RAI,
                DT_DM: formData.DT_DM,
                FL_VISTORIA_ANTECIPADA: formData.FL_VISTORIA_ANTECIPADA,
                VL_TAXA_JUROS_ANUAL: formData.VL_TAXA_JUROS_ANUAL?.replace(
                    ",",
                    "."
                ),
                VL_TAXA_JUROS_MENSAL: formData.VL_TAXA_JUROS_MENSAL?.replace(
                    ",",
                    "."
                ),
                DS_CEP: cep ? cep : "",
                DS_SPE_CEP: cepSPE ? cepSPE : "",
            }).then(() => {
                props.updateList();
                if (updateListEmp) updateListEmp();
                if (updateListDocumentos) updateListDocumentos();
            });
        } else {
            atualizarProduto({
                ...formData,
                ID_CLASSIFICACAO_PRODUTO: 1,
                DT_AGI: formData.DT_AGI,
                DT_RECEBIMENTO_AREA_COMUM: formData.DT_RECEBIMENTO_AREA_COMUM,
                NR_TORRES: formData.NR_TORRES,
                NR_UNIDADES_TORRE: formData.NR_UNIDADES_TORRE,
                DS_TIPO_VAGA: formData.DS_TIPO_VAGA,
                DS_MURO: formData.DS_MURO,
                NR_ANDAMENTO_OBRA: formData.NR_ANDAMENTO_OBRA,
                DS_OPCAO_PLANTA: formData.DS_OPCAO_PLANTA,
                DS_FICHA_TECNICA: formData.DS_FICHA_TECNICA,
                DS_MATRICULA_IMOVEL: formData.DS_MATRICULA_IMOVEL,
                DS_PRODUTO: formData.DS_PRODUTO,
                DT_HABITESE: formData.DT_HABITESE,
                DT_INICIO_GARANTIA: formData.DT_INICIO_GARANTIA,
                DT_LANCAMENTO: formData.DT_LANCAMENTO,
                DT_PATRIMONIO_AFETACAO: formData.DT_PATRIMONIO_AFETACAO,
                DT_PREVISAO_CONCLUSAO: formData.DT_PREVISAO_CONCLUSAO,
                ID_PRODUTO: props.row?.ID_EMPREENDIMENTO ?? 0,
                NR_ANDARES: formData.NR_ANDARES,
                DT_RAI: formData.DT_RAI,
                DT_DM: formData.DT_DM,
                FL_VISTORIA_ANTECIPADA: formData.FL_VISTORIA_ANTECIPADA,
                VL_TAXA_JUROS_ANUAL: formData.VL_TAXA_JUROS_ANUAL?.replace(
                    ",",
                    "."
                ),
                VL_TAXA_JUROS_MENSAL: formData.VL_TAXA_JUROS_MENSAL?.replace(
                    ",",
                    "."
                ),
                DS_CEP: cep ? cep : "",
                DS_SPE_CEP: cepSPE ? cepSPE : "",
            }).then(() => {
                props.updateList();
                if (updateListEmp) updateListEmp();
                if (updateListDocumentos) updateListDocumentos();
            });
        }
    }

    const isLoading = cadastrarLoading || atualizarProdutoLoading;

    const columnsUnidades: Array<ColumnDescription<IUnidadeEmpDTO>> = [
        {
            dataField: "DS_UNIDADE",
            text: "Descrição",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "DS_BLOCO",
            text: "Bloco",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "NR_VAGAS",
            text: "Nº Vagas",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "NR_QUARTOS",
            text: "Nº Quartos",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "NR_AREA_TOTAL",
            text: "Área Total",
            align: "center",
            headerAlign: "center",
        },
        {
            dataField: "VL_METRO_QUADRADO",
            text: "Valor do m²",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => <span>{c} m²</span>,
        },
        {
            dataField: "VL_PRECO_VENDA",
            text: "Preço de Venda",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => <span>{formatMoneyReais(c)}</span>,
        },
        {
            dataField: "DS_STATUS",
            text: "Status",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => (
                <div>
                    <span
                        className={`label label-lg label-light-${
                            row.DS_STATUS === "VENDIDO"
                                ? "success"
                                : row.DS_STATUS === "PERMUTADO"
                                ? "info"
                                : row.DS_STATUS === "RESERVADO"
                                ? "warning"
                                : row.DS_STATUS === "DISPONÍVEL"
                                ? "primary"
                                : ""
                        } label-inline`}
                    >
                        {row.DS_STATUS ?? "-"}
                    </span>
                </div>
            ),
        },
    ];

    const columnsDocumentos: Array<ColumnDescription<IDocumentoComIcone>> = [
        {
            dataField: "DS_DOCUMENTO_PRODUTO",
            text: "Documento",
            formatter: (c, row) => <span className="p-3">{c}</span>,
        },
        {
            dataField: "DS_TIPO_DOCUMENTO",
            text: "Tipo Documento",
            formatter: (c, row) => <span className="p-3">{c}</span>,
        },
        {
            dataField: "FL_DESTAQUE",
            text: "Destaque",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => <span>{c ? "Sim" : "Não"}</span>,
        },
        {
            dataField: "FL_IMG_IMPLANTACAO",
            text: "Implantação",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => <span>{c ? "Sim" : "Não"}</span>,
        },
        {
            dataField: "",
            text: "Visualizar",
            formatter: (c, row) =>
                row.DS_LINK_DRIVE && (
                    <a
                        href={row.DS_LINK_DRIVE}
                        className="font-weight-bold btn btn-outline-info m-2"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <FontAwesomeIcon icon={faEye} />
                    </a>
                ),
        },
        {
            dataField: "",
            text: "Excluir",
            formatter: (c, row) => (
                <button
                    className="font-weight-bold btn btn-outline-danger m-2"
                    type="button"
                    onClick={() => {
                        Swal.fire({
                            title: "Deseja realmente excluir esse documento?",
                            showCancelButton: true,
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                        }).then((res) => {
                            if (res.isConfirmed)
                                RemoverDocumentosPorProduto(
                                    row.ID_DOCUMENTO_PRODUTO
                                ).then(() => {
                                    updateListDocumentos();
                                });
                        });
                    }}
                    disabled={RemoverDocumentosPorProdutoLoading}
                >
                    {RemoverDocumentosPorProdutoLoading ? (
                        <Spinner size="sm" />
                    ) : (
                        <FontAwesomeIcon icon={faTrash} />
                    )}
                </button>
            ),
        },
    ];

    const columnsAlteracoes: Array<ColumnDescription<IAlteracoesProdutoDTO>> = [
        {
            dataField: "DS_PRODUTO_LOG",
            text: "Tipo de Alteração",
            formatter: (c, row) => <span className="p-3">{c}</span>,
        },
        {
            dataField: "DT_PRODUTO_LOG",
            text: "Descrição",
            align: "center",
            headerAlign: "center",
            formatter: (c, row) => (
                <span>{c ? moment(c).format("DD/MM/YYYY") : "-"}</span>
            ),
        },
    ];

    const handleFileSelect = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = Array.from(e.target.files || []).map(
            (file, index) => {
                return {
                    ID_DOCUMENTO_PRODUTO: Math.random(),
                    ID_PRODUTO: props.row?.ID_EMPREENDIMENTO ?? 0,
                    DS_DOCUMENTO_PRODUTO: "",
                    DS_NOME_ARQUIVO: file.name,
                    ID_TIPO_DOCUMENTO: 0,
                    DS_LINK_DRIVE: "",
                    FL_DESTAQUE: false,
                    FL_IMG_IMPLANTACAO: false,
                    DS_TIPO_DOCUMENTO: file.type,
                    FL_DOCUMENTO_FILHO: false,
                    size: file.size,
                    type: file.type,
                    File: file,
                };
            }
        );
        setDocuments([...documents, ...selectedFiles]);
        setDescricaoDocs([
            ...descricaoDocs,
            ...selectedFiles.map((doc) => ({
                ID_DOCUMENTO_PRODUTO: doc.ID_DOCUMENTO_PRODUTO,
                DS_DOCUMENTO_PRODUTO: "",
            })),
        ]);
    };

    const handleFileUpload = async () => {
        const totalDocuments = documents.length;

        for (let i = 0; i < totalDocuments; i++) {
            const doc = documents[i];
            const formData = new FormData();
            formData.append("File", doc.File as Blob);

            await InserirDocumentosPorProduto(
                props.row?.ID_EMPREENDIMENTO ?? 0,
                descricaoDocs[i].DS_DOCUMENTO_PRODUTO,
                doc.DS_NOME_ARQUIVO,
                doc.ID_TIPO_DOCUMENTO,
                doc.DS_LINK_DRIVE,
                doc.FL_DESTAQUE,
                doc.FL_IMG_IMPLANTACAO,
                doc.DS_TIPO_DOCUMENTO,
                doc.FL_DOCUMENTO_FILHO,
                formData,
                0
            ).then(() => {
                updateListDocumentos();
            });

            setCompletedUploads((prev) => prev + 1);
        }

        updateListDocumentos();
        setDocuments([]);
        setDescricaoDocs([]);
        setCompletedUploads(0);
    };

    const handleDelete = (id: number) => {
        setDocuments(
            documents.filter((doc) => doc.ID_DOCUMENTO_PRODUTO !== id)
        );
    };

    const handleToggleFeature = (id: number) => {
        setDocuments((prevDocuments) =>
            prevDocuments.map((doc) =>
                doc.ID_DOCUMENTO_PRODUTO === id
                    ? { ...doc, FL_DESTAQUE: !doc.FL_DESTAQUE }
                    : doc
            )
        );
    };

    const handleToggleImplementation = (id: number) => {
        setDocuments((prevDocuments) =>
            prevDocuments.map((doc) =>
                doc.ID_DOCUMENTO_PRODUTO === id
                    ? { ...doc, FL_IMG_IMPLANTACAO: !doc.FL_IMG_IMPLANTACAO }
                    : doc
            )
        );
    };

    const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setIsDragging(false);

        const droppedFiles = Array.from(e.dataTransfer.files).map((file) => {
            return {
                ID_DOCUMENTO_PRODUTO: Math.random(),
                ID_PRODUTO: props.row?.ID_EMPREENDIMENTO ?? 0,
                DS_DOCUMENTO_PRODUTO: "",
                DS_NOME_ARQUIVO: file.name,
                ID_TIPO_DOCUMENTO: 0,
                DS_LINK_DRIVE: "",
                FL_DESTAQUE: false,
                FL_IMG_IMPLANTACAO: false,
                DS_TIPO_DOCUMENTO: "",
                FL_DOCUMENTO_FILHO: false,
                size: file.size,
                type: file.type,
                File: file,
            };
        });

        setDocuments([...documents, ...droppedFiles]);
        setDescricaoDocs([
            ...descricaoDocs,
            ...droppedFiles.map((doc) => ({
                ID_DOCUMENTO_PRODUTO: doc.ID_DOCUMENTO_PRODUTO,
                DS_DOCUMENTO_PRODUTO: "",
            })),
        ]);
    };

    const columnsDocsAdicionados: Array<ColumnDescription> = [
        {
            dataField: "delete",
            text: "Excluir?",
            align: "center",
            formatter: (_, document) => (
                <button
                    className="font-weight-bold btn btn-outline-danger m-2"
                    onClick={() => handleDelete(document.ID_PRODUTO ?? 0)}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            ),
        },
        { dataField: "DS_NOME_ARQUIVO", text: "Nome" },
        {
            dataField: "DS_DOCUMENTO_PRODUTO",
            text: "Descrição",
            formatter: (_, document) => {
                return (
                    <input
                        type="text"
                        className="form-control"
                        onChange={(e) => {
                            setDescricaoDocs((prevDocuments) =>
                                prevDocuments.map((doc) =>
                                    doc.ID_DOCUMENTO_PRODUTO ===
                                    document.ID_DOCUMENTO_PRODUTO
                                        ? {
                                              ...doc,
                                              DS_DOCUMENTO_PRODUTO:
                                                  e.target.value,
                                          }
                                        : doc
                                )
                            );
                        }}
                    />
                );
            },
        },
        {
            dataField: "ID_TIPO_DOCUMENTO",
            text: "Tipo",
            formatter: (_, document) => (
                <select
                    className="form-control"
                    value={document.ID_TIPO_DOCUMENTO}
                    onChange={(e) => {
                        const idTipoDoc = Number(e.target.value);
                        setDocuments((prevDocuments) =>
                            prevDocuments.map((doc) =>
                                doc.ID_DOCUMENTO_PRODUTO ===
                                document.ID_DOCUMENTO_PRODUTO
                                    ? {
                                          ...doc,
                                          ID_TIPO_DOCUMENTO: idTipoDoc,
                                      }
                                    : doc
                            )
                        );
                    }}
                >
                    <option></option>
                    {lstTipoDocs?.map((tipoDoc) => (
                        <option
                            key={tipoDoc.ID_TIPO_DOCUMENTO}
                            value={tipoDoc.ID_TIPO_DOCUMENTO}
                        >
                            {tipoDoc.DS_TIPO_DOCUMENTO}
                        </option>
                    ))}
                </select>
            ),
        },
        {
            dataField: "FL_DESTAQUE",
            text: "Destaque",
            align: "center",
            formatter: (_, document) => (
                <div className="mt-3">
                    <Switch
                        checked={document.FL_DESTAQUE}
                        onChange={() =>
                            handleToggleFeature(
                                document.ID_DOCUMENTO_PRODUTO ?? 0
                            )
                        }
                    />
                </div>
            ),
        },
        {
            dataField: "FL_IMG_IMPLANTACAO",
            text: "Implantação",
            align: "center",
            formatter: (_, document) => (
                <div className="mt-3">
                    <Switch
                        checked={document.FL_IMG_IMPLANTACAO}
                        onChange={() =>
                            handleToggleImplementation(
                                document.ID_DOCUMENTO_PRODUTO ?? 0
                            )
                        }
                    />
                </div>
            ),
        },
        {
            dataField: "size",
            text: "Tamanho",
            formatter: (_: any, document) => {
                const sizeInMB = document.size / (1024 * 1024);
                return (
                    <div>
                        <span>{sizeInMB.toFixed(2)} MB</span>
                        {sizeInMB > 5 && (
                            <div style={{ color: "red" }}>
                                Tamanho máximo deve ser 5 MB
                            </div>
                        )}
                    </div>
                );
            },
        },
    ];
    const regexDriveLink = /\/d\/(.*?)(?:\/|$)/;
    const regexUCLink = /[?&]id=([^&]+)/;

    const matchDrive = lstDocumentos
        ?.find((d) => d.FL_DESTAQUE === true)
        ?.DS_LINK_DRIVE.match(regexDriveLink);
    const matchUC = lstDocumentos
        ?.find((d) => d.FL_DESTAQUE === true)
        ?.DS_LINK_DRIVE.match(regexUCLink);

    const fileId = matchDrive ? matchDrive[1] : matchUC ? matchUC[1] : null;

    return (
        <>
            {props.row?.ID_EMPREENDIMENTO && (
                <div className="px-8 pt-1 pb-2">
                    <div className="row">
                        <div className="card card-custom col-12 py-6 w-100">
                            <OrSpinner loading={empLoading} spinner="capys">
                                <div className="">
                                    <div className="d-flex">
                                        <div className="flex-shrink-0 mr-7 mt-lg-0 mt-3">
                                            <>
                                                <div className="symbol symbol-50 symbol-lg-120">
                                                    <img
                                                        src={`https://drive.google.com/thumbnail?id=${fileId}&sz=w2000`}
                                                        loading="lazy"
                                                        alt="Imagem do produto"
                                                    />
                                                </div>
                                                <div className="symbol symbol-50 symbol-lg-120 symbol-primary d-none">
                                                    <span className="font-size-h3 symbol-label font-weight-boldest">
                                                        JM
                                                    </span>
                                                </div>
                                            </>
                                        </div>

                                        <div className="flex-grow-1">
                                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                                <div className="mr-3">
                                                    <a
                                                        href="#/"
                                                        className="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3"
                                                    >
                                                        {props.row
                                                            ?.DS_EMPREENDIMENTO
                                                            ? props.row
                                                                  ?.DS_EMPREENDIMENTO
                                                            : emp
                                                                  ?.QUALIFICACAO_EMPREENDIMENTO
                                                                  .DS_DESCRICAO}
                                                        <i className="flaticon2-correct text-success icon-md ml-2" />
                                                    </a>

                                                    <div className="d-flex flex-wrap my-2">
                                                        {emp
                                                            ?.QUALIFICACAO_EMPREENDIMENTO
                                                            .DS_ENDERECO_SITE ? (
                                                            <a
                                                                href="#/"
                                                                className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                                                            >
                                                                <span className="svg-icon svg-icon-sm svg-icon-gray-500 mr-1">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faGlobe
                                                                        }
                                                                    />
                                                                </span>{" "}
                                                                {
                                                                    emp
                                                                        ?.QUALIFICACAO_EMPREENDIMENTO
                                                                        .DS_ENDERECO_SITE
                                                                }
                                                            </a>
                                                        ) : null}

                                                        {emp
                                                            ?.QUALIFICACAO_EMPREENDIMENTO
                                                            .DS_TIPO_INCORPORACAO ? (
                                                            <a
                                                                href="#/"
                                                                className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                                                            >
                                                                <span className="svg-icon svg-icon-sm svg-icon-gray-500 mr-1">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faBuilding
                                                                        }
                                                                    />
                                                                </span>{" "}
                                                                {
                                                                    emp
                                                                        ?.QUALIFICACAO_EMPREENDIMENTO
                                                                        .DS_TIPO_INCORPORACAO
                                                                }
                                                            </a>
                                                        ) : null}

                                                        {emp?.LOCALIZACAO
                                                            ?.DS_CIDADE ? (
                                                            <a
                                                                href="#/"
                                                                className="text-muted text-hover-primary font-weight-bold"
                                                            >
                                                                <span className="svg-icon svg-icon-sm svg-icon-gray-500 mr-1">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faMapMarkerAlt
                                                                        }
                                                                    />
                                                                </span>{" "}
                                                                {
                                                                    emp
                                                                        ?.LOCALIZACAO
                                                                        ?.DS_CIDADE
                                                                }{" "}
                                                                {emp
                                                                    ?.LOCALIZACAO
                                                                    ?.DS_ESTADO
                                                                    ? "- " +
                                                                      emp
                                                                          ?.LOCALIZACAO
                                                                          ?.DS_ESTADO
                                                                    : ""}
                                                            </a>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                {/* <div className="my-lg-0 my-1">
                                                <a
                                                    href="#/"
                                                    className="btn btn-sm btn-light-success font-weight-bolder text-uppercase mr-3"
                                                >
                                                    Reports
                                                </a>
                                                <a
                                                    href="#/"
                                                    className="btn btn-sm btn-info font-weight-bolder text-uppercase"
                                                >
                                                    New Task
                                                </a>
                                            </div> */}
                                            </div>
                                            <div className="d-flex align-items-center flex-wrap justify-content-between">
                                                <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5">
                                                    {emp
                                                        ?.QUALIFICACAO_EMPREENDIMENTO
                                                        .DS_FICHA_TECNICA &&
                                                        emp
                                                            ?.QUALIFICACAO_EMPREENDIMENTO
                                                            .DS_FICHA_TECNICA}
                                                </div>
                                                <div className="d-flex flex-wrap align-items-center py-2">
                                                    <div className="d-flex align-items-center mr-10">
                                                        <div className="mr-6">
                                                            {emp
                                                                ?.CRONOGRAMA_DATAS
                                                                .DT_LANCAMENTO && (
                                                                <>
                                                                    <div className="font-weight-bold mb-2">
                                                                        Dt.
                                                                        Lançamento
                                                                    </div>
                                                                    <span className="btn btn-sm btn-text btn-light-primary text-uppercase font-weight-bold">
                                                                        {moment(
                                                                            emp
                                                                                ?.CRONOGRAMA_DATAS
                                                                                .DT_LANCAMENTO
                                                                        ).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                        <div className="mr-6">
                                                            {emp
                                                                ?.CRONOGRAMA_DATAS
                                                                .DT_PREVISAO_CONCLUSAO && (
                                                                <>
                                                                    <div className="font-weight-bold mb-2">
                                                                        Dt.
                                                                        Previsão
                                                                        Conclusão
                                                                    </div>
                                                                    <span className="btn btn-sm btn-text btn-light-danger text-uppercase font-weight-bold">
                                                                        {moment(
                                                                            emp
                                                                                ?.CRONOGRAMA_DATAS
                                                                                .DT_PREVISAO_CONCLUSAO
                                                                        ).format(
                                                                            "DD/MM/YYYY"
                                                                        )}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 flex-shrink-0 w-150px w-xl-300px mt-4 mt-sm-0">
                                                        <span className="font-weight-bold">
                                                            % de Andamento Obra
                                                        </span>
                                                        <div className="progress mt-2 mb-2">
                                                            <ProgressBar
                                                                now={
                                                                    emp
                                                                        ?.CONFIGURACAO_VENDAS
                                                                        .VL_PERCENT_ANDAMENTO_OBRA ??
                                                                    0
                                                                }
                                                                className="progress-xl w-100"
                                                            />
                                                        </div>
                                                        <span className="font-weight-bolder text-dark">
                                                            {
                                                                emp
                                                                    ?.CONFIGURACAO_VENDAS
                                                                    .VL_PERCENT_ANDAMENTO_OBRA
                                                            }{" "}
                                                            %
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*end: Content*/}
                                        </div>
                                        {/*end: Info*/}
                                    </div>
                                    <div className="separator separator-solid my-7" />
                                    {/*begin: Items*/}
                                    <div className="d-flex align-items-center flex-wrap">
                                        {/*begin: Item*/}
                                        <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                            <span className="mr-4">
                                                {/* <i className="flaticon-piggy-bank icon-2x text-muted font-weight-bold" /> */}
                                                <FontAwesomeIcon
                                                    icon={faUnity}
                                                    className="icon-2x text-muted font-weight-bold"
                                                />
                                            </span>
                                            <div className="d-flex flex-column text-dark-75">
                                                <span className="font-weight-bolder font-size-sm">
                                                    Número de Unidades
                                                </span>
                                                <span className="font-weight-bolder font-size-h5">
                                                    {
                                                        emp
                                                            ?.UNIDADE_EMPREENDIMENTO
                                                            .length
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                            <span className="mr-4">
                                                <i className="flaticon-confetti icon-2x text-muted font-weight-bold" />
                                            </span>
                                            <div className="d-flex flex-column text-dark-75">
                                                <span className="font-weight-bolder font-size-sm">
                                                    VGV Total
                                                </span>
                                                <span className="font-weight-bolder font-size-h5">
                                                    <span className="text-dark-50 font-weight-bold">
                                                        R$
                                                    </span>
                                                    {emp?.UNIDADE_EMPREENDIMENTO.reduce(
                                                        (sum, ua) =>
                                                            sum +
                                                            (ua.VL_PRECO_VENDA ??
                                                                0),
                                                        0
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                            <span className="mr-4">
                                                <i className="flaticon-pie-chart icon-2x text-muted font-weight-bold" />
                                            </span>
                                            <div className="d-flex flex-column text-dark-75">
                                                <span className="font-weight-bolder font-size-sm">
                                                    Segmento
                                                </span>
                                                <span className="font-weight-bolder font-size-h6">
                                                    {
                                                        emp
                                                            ?.QUALIFICACAO_EMPREENDIMENTO
                                                            .DS_SEGMENTO
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                            <span className="mr-4">
                                                <i className="flaticon-pie-chart icon-2x text-muted font-weight-bold" />
                                            </span>
                                            <div className="d-flex flex-column text-dark-75">
                                                <span className="font-weight-bolder font-size-sm">
                                                    Situação Comercial
                                                </span>
                                                <span className="font-weight-bolder font-size-h6">
                                                    {
                                                        emp?.CONFIGURACAO_VENDAS
                                                            .DS_SITUACAO_COMERCIAL
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                                            <span className="mr-4">
                                                <i className="flaticon-pie-chart icon-2x text-muted font-weight-bold" />
                                            </span>
                                            <div className="d-flex flex-column text-dark-75">
                                                <span className="font-weight-bolder font-size-sm">
                                                    Situação Obra
                                                </span>
                                                <span className="font-weight-bolder font-size-h6">
                                                    {
                                                        emp?.CONFIGURACAO_VENDAS
                                                            .DS_SITUACAO_OBRA
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </OrSpinner>
                        </div>
                    </div>
                </div>
            )}
            <FormProvider {...FormMethods}>
                <UnForm
                    usingContext
                    handleSubmit={handleCadastrarOuEditarProduto}
                >
                    <div className="px-8 pt-1">
                        <div className="row">
                            <div className="card card-custom col-12 py-6">
                                <div className="card-header">
                                    <div className="nav-scroll-wrapper">
                                        <ul
                                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-scroll"
                                            role="tablist"
                                        >
                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link active"
                                                    data-toggle="tab"
                                                    href="#qualificacaoEmpreendimento"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faBuilding
                                                                }
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Qualificação
                                                    </span>
                                                </a>
                                            </li>
                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#localizacao"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faMapMarkerAlt
                                                                }
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Localização
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#caracteristicas"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={faListAlt}
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Características
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#cronogramaDatas"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faDatabase
                                                                }
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Cronograma Datas
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#SPE"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={faSpa}
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        SPE
                                                    </span>
                                                </a>
                                            </li>
                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#mapaImplantacao"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={faMap}
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Mapa Implantação
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#tabelaPreco"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faMoneyBill
                                                                }
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Tabela de preço
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#vendas"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={
                                                                    faMoneyBill
                                                                }
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Vendas
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#vistoria"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={faKey}
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Vistoria
                                                    </span>
                                                </a>
                                            </li>

                                            <li className="nav-item mr-3">
                                                <a
                                                    className="nav-link"
                                                    data-toggle="tab"
                                                    href="#integracao"
                                                >
                                                    <span className="nav-icon mr-2">
                                                        <span className="svg-icon mr-3">
                                                            <FontAwesomeIcon
                                                                icon={faItunes}
                                                            />
                                                        </span>
                                                    </span>
                                                    <span className="nav-text font-weight-bold">
                                                        Integração
                                                    </span>
                                                </a>
                                            </li>

                                            {props.row?.ID_EMPREENDIMENTO && (
                                                <>
                                                    <li className="nav-item mr-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#unidades"
                                                        >
                                                            <span className="nav-icon mr-2">
                                                                <span className="svg-icon mr-3">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faUnity
                                                                        }
                                                                    />
                                                                </span>
                                                            </span>
                                                            <span className="nav-text font-weight-bold">
                                                                Unidades
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="nav-item mr-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#documentos"
                                                        >
                                                            <span className="nav-icon mr-2">
                                                                <span className="svg-icon mr-3">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faFile
                                                                        }
                                                                    />
                                                                </span>
                                                            </span>
                                                            <span className="nav-text font-weight-bold">
                                                                Documentos
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li className="nav-item mr-3">
                                                        <a
                                                            className="nav-link"
                                                            data-toggle="tab"
                                                            href="#alteracoes"
                                                        >
                                                            <span className="nav-icon mr-2">
                                                                <span className="svg-icon mr-3">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faExchangeAlt
                                                                        }
                                                                    />
                                                                </span>
                                                            </span>
                                                            <span className="nav-text font-weight-bold">
                                                                Alterações
                                                            </span>
                                                        </a>
                                                    </li>
                                                </>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="tab-content pt-5">
                                        <div
                                            className="tab-pane active"
                                            id="qualificacaoEmpreendimento"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .DS_DESCRICAO
                                                        }
                                                        name="DS_PRODUTO"
                                                        label="Descrição"
                                                        registerOptions={{
                                                            required:
                                                                "Insira o nome do produto",
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.LazySelect
                                                        name="ID_SEGMENTO"
                                                        label="Segmento"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .ID_SEGMENTO
                                                        }
                                                        controller={
                                                            ListarSegmentoController
                                                        }
                                                        getDS={(s) =>
                                                            s.DS_SEGMENTO
                                                        }
                                                        getKeyValue={(s) =>
                                                            s.ID_SEGMENTO
                                                        }
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.LazySelect
                                                        name="ID_TIPO_INCORPORACAO"
                                                        label="Tipo Incorporação"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .ID_TIPO_INCORPORACAO
                                                        }
                                                        controller={
                                                            ListarTipoIncorporacaoController
                                                        }
                                                        getDS={(t) =>
                                                            t.DS_TIPO_INCORPORACAO
                                                        }
                                                        getKeyValue={(t) =>
                                                            t.ID_TIPO_INCORPORACAO
                                                        }
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_ENDERECO_SITE"
                                                        label="Endereço do Site"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .DS_ENDERECO_SITE
                                                        }
                                                    />
                                                </div>
                                                {/* <div className="form-group col-3">
                                        <UnForm.LazySelect
                                            label="Classificação Produto"
                                            name="ID_CLASSIFICACAO"
                                            controller={
                                                ListarClassificacaoProdutoController
                                            }
                                            getDS={(e) =>
                                                e.DS_CLASSIFICACAO_PRODUTO
                                            }
                                            getKeyValue={(e) =>
                                                e.ID_CLASSIFICACAO_PRODUTO
                                            }
                                            className="form-control"
                                        >
                                            <option></option>
                                        </UnForm.LazySelect>
                                    </div> */}
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_ALVARA"
                                                        label="Nº Alvará"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .NR_ALVARA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_INFO_HABITESE"
                                                        label="Informações Habite-se"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .DS_INFORMACOES_HABITASE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_REGISTRO_INCORPORACAO"
                                                        label="Registro de Incorporação"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .DS_REGISTRO_INCORPORACAO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-12">
                                                    <UnForm.Textarea
                                                        // type="text"
                                                        name="DS_FICHA_TECNICA"
                                                        label="Ficha Técnica"
                                                        defaultValue={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .DS_FICHA_TECNICA
                                                        }
                                                        rows={3}
                                                    />
                                                </div>{" "}
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="localizacao"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.LazySelect
                                                        name="ID_REGIAO"
                                                        label="Região"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .ID_REGIAO
                                                        }
                                                        controller={
                                                            ListarRegiaoController
                                                        }
                                                        getDS={(r) =>
                                                            r.DS_REGIAO
                                                        }
                                                        getKeyValue={(r) =>
                                                            r.ID_REGIAO
                                                        }
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                </div>

                                                <div className="col-3">
                                                    <label>CEP</label>
                                                    <div className="input-icon input-icon-right">
                                                        <input
                                                            name="DS_CEP"
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="CEP"
                                                            value={cep}
                                                            onChange={(e) =>
                                                                setCep(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            defaultValue={
                                                                emp?.LOCALIZACAO
                                                                    .DS_CEP
                                                            }
                                                            {...FormMethods}
                                                            ref={FormMethods.register()}
                                                        />

                                                        <span
                                                            typeof="button"
                                                            onClick={async () => {
                                                                await buscarCEP(
                                                                    Number(cep)
                                                                ).then(
                                                                    (res) => {
                                                                        FormMethods.setValue(
                                                                            "DS_CIDADE",
                                                                            res.localidade
                                                                        );
                                                                        FormMethods.setValue(
                                                                            "DS_ESTADO",
                                                                            res.uf
                                                                        );
                                                                        FormMethods.setValue(
                                                                            "DS_BAIRRO",
                                                                            res.bairro
                                                                        );
                                                                        FormMethods.setValue(
                                                                            "DS_LOGRADOURO",
                                                                            res.logradouro
                                                                        );
                                                                    }
                                                                );
                                                            }}
                                                        >
                                                            {buscarCEPLoading ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <i className="flaticon2-search-1 icon-md"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_ESTADO"
                                                        label="Estado"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .DS_ESTADO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_CIDADE"
                                                        label="Cidade"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .DS_CIDADE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_BAIRRO"
                                                        label="Bairro"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .DS_BAIRRO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_LOGRADOURO"
                                                        label="Logradouro"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .DS_LOGRADOURO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_NUMERO"
                                                        label="Número"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .NR_NUMERO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_CIDADE_COMARCA"
                                                        label="Cidade da Comarca"
                                                        defaultValue={
                                                            emp?.LOCALIZACAO
                                                                .DS_CIDADE_COMARCA
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="caracteristicas"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_UNIDADES_TORRE"
                                                        label="Núm. de Unidades"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .NR_UNIDADES
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_QUADRAS"
                                                        label="Núm. de Quadras / Blocos"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .NR_QUADRAS
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_ANDARES"
                                                        label="Núm. de Andares"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .NR_ANDARES
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_TIPO_VAGA"
                                                        label="Tipo de Vaga"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .DS_TIPO_VAGA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_MURO"
                                                        label="Muro"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .DS_MURO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_OPCAO_PLANTA"
                                                        label="Opção de Planta"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .DS_OPCAO_PLANTA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_TORRES"
                                                        label="Número de Torres"
                                                        defaultValue={
                                                            emp
                                                                ?.CARACTERISTICAS_EMPREENDIMENTO
                                                                .NR_TORRES
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="cronogramaDatas"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_INICIO_GARANTIA"
                                                        label="Data Início Garantia"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_INICIO_GARANTIA?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_AGI"
                                                        label="Dt. AGI"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_AGI?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_RECEBIMENTO_AREA_COMUM"
                                                        label="Dt. Recebimento Área Comum"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_RECEBIMENTO_AREA_COMUM?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_HABITESE"
                                                        label="Dt. Habitese"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_HABITESE?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_LANCAMENTO"
                                                        label="Dt. Lançamento"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_LANCAMENTO?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_PATRIMONIO_AFETACAO"
                                                        label="Dt. Patrimônio Afetação"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_PATRIMONIO_AFETACAO?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_PREVISAO_CONCLUSAO"
                                                        label="Dt. Previsão Conclusão"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_PREVISAO_CONCLUSAO?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_RAI"
                                                        label="Dt. da RAI"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_RAI?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_DM"
                                                        label="Dt. da Demanda Mínima"
                                                        defaultValue={emp?.CRONOGRAMA_DATAS.DT_DEMANDA_MINIMA?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="tab-pane"
                                            id="SPE"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_NOME"
                                                        label="Nome da SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_NOME_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="NR_SPE_CNPJ"
                                                        label="CNPJ SPE"
                                                        maxLength={18}
                                                        onChange={
                                                            formatterCPF_CNPJ
                                                        }
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .NR_CNPJ_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_TELEFONE"
                                                        label="Telefone SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .NR_TELEFONE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_EMAIL"
                                                        label="Email da SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_EMAIL_SPE
                                                        }
                                                    />
                                                </div>

                                                <div className="col-3">
                                                    <label>CEP SPE</label>
                                                    <div className="input-icon input-icon-right">
                                                        <input
                                                            name="DS_CEP_SPE"
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="CEP SPE"
                                                            value={cepSPE}
                                                            onChange={(e) =>
                                                                setCepSPE(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            {...FormMethods}
                                                            ref={FormMethods.register()}
                                                            defaultValue={
                                                                emp?.DADOS_SPE
                                                                    .DS_EMAIL_SPE
                                                            }
                                                        />

                                                        <span
                                                            typeof="button"
                                                            onClick={async () => {
                                                                await buscarCEP(
                                                                    Number(
                                                                        cepSPE
                                                                    )
                                                                ).then(
                                                                    (res) => {
                                                                        FormMethods.setValue(
                                                                            "DS_SPE_CIDADE",
                                                                            res.localidade
                                                                        );
                                                                        FormMethods.setValue(
                                                                            "DS_SPE_ESTADO",
                                                                            res.uf
                                                                        );
                                                                        FormMethods.setValue(
                                                                            "DS_SPE_BAIRRO",
                                                                            res.bairro
                                                                        );
                                                                        FormMethods.setValue(
                                                                            "DS_SPE_LOGRADOURO",
                                                                            res.logradouro
                                                                        );
                                                                    }
                                                                );
                                                            }}
                                                        >
                                                            {buscarCEPLoading ? (
                                                                <Spinner size="sm" />
                                                            ) : (
                                                                <i className="flaticon2-search-1 icon-md"></i>
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_ESTADO"
                                                        label="Estado SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_ESTADO_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_CIDADE"
                                                        label="Cidade SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_CIDADE_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_BAIRRO"
                                                        label="Bairro SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_BAIRRO_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_LOGRADOURO"
                                                        label="Logradouro SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_LOGRADOURO_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_SPE_NUMERO"
                                                        label="Número SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .NR_NUMERO_SPE
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_SPE_COMPLEMENTO"
                                                        label="Complemento SPE"
                                                        defaultValue={
                                                            emp?.DADOS_SPE
                                                                .DS_COMPLEMENTO_SPE
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="mapaImplantacao"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_TAMANHO_PIXEL_MAPA"
                                                        label="Tamanho Marcador"
                                                        defaultValue={
                                                            emp
                                                                ?.MAPA_IMPLANTACAO
                                                                .NR_TAMANHO_MARCADOR
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_TAMANHO_FONTE_MAPA"
                                                        label="Tamanho Fonte"
                                                        defaultValue={
                                                            emp
                                                                ?.MAPA_IMPLANTACAO
                                                                .NR_TAMANHO_FONTE
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="tabelaPreco"
                                            role="tabpanel"
                                        >
                                            <div className="d-flex justify-content-end mb-4">
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={() => {
                                                        setShow(true);
                                                        setModal({
                                                            headerComponent:
                                                                "Adicionar Financiamento",
                                                            IconHeader: faPlus,
                                                            Component: () => (
                                                                <AdicionarEditarFinanciamento
                                                                    ID_PRODUTO={
                                                                        props
                                                                            .row
                                                                            ?.ID_EMPREENDIMENTO ??
                                                                        0
                                                                    }
                                                                    setShow={
                                                                        setShow
                                                                    }
                                                                    updateListFinanciamento={
                                                                        updateListFinanciamento
                                                                    }
                                                                />
                                                            ),
                                                            size: "xl",
                                                        });
                                                    }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faPlus}
                                                        className="mr-2"
                                                    />
                                                    Adicionar Financiamento
                                                </button>
                                            </div>
                                            <OrSpinner
                                                loading={
                                                    lstFinanciamentoLoading
                                                }
                                                spinner="capys"
                                            >
                                                {lstFinanciamento?.map((f) => (
                                                    <div
                                                        key={
                                                            f.ID_FINANCEIRO_EMPREENDIMENTO
                                                        }
                                                        className="card card-custom mb-4"
                                                    >
                                                        <div className="card-header">
                                                            <h3 className="card-title">
                                                                Financiamento{" "}
                                                                {
                                                                    f.ID_FINANCEIRO_EMPREENDIMENTO
                                                                }
                                                            </h3>

                                                            <div className="card-toolbar">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-outline-primary mr-2"
                                                                    onClick={() => {
                                                                        setShow(
                                                                            true
                                                                        );
                                                                        setModal(
                                                                            {
                                                                                headerComponent:
                                                                                    "Editar Financiamento",
                                                                                IconHeader:
                                                                                    faEdit,
                                                                                Component:
                                                                                    () => (
                                                                                        <AdicionarEditarFinanciamento
                                                                                            ID_PRODUTO={
                                                                                                props
                                                                                                    .row
                                                                                                    ?.ID_EMPREENDIMENTO ??
                                                                                                0
                                                                                            }
                                                                                            setShow={
                                                                                                setShow
                                                                                            }
                                                                                            updateListFinanciamento={
                                                                                                updateListFinanciamento
                                                                                            }
                                                                                            financiamento={
                                                                                                f
                                                                                            }
                                                                                        />
                                                                                    ),
                                                                                size: "xl",
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faEdit
                                                                        }
                                                                    />
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-icon btn-outline-danger"
                                                                    disabled={
                                                                        deletarFinanciamentoProdutoLoading
                                                                    }
                                                                    onClick={() => {
                                                                        Swal.fire(
                                                                            {
                                                                                title: "Tem certeza que deseja excluir o financiamento?",
                                                                                text: "Esta ação não poderá ser desfeita!",
                                                                                icon: "warning",
                                                                                showCancelButton:
                                                                                    true,
                                                                                confirmButtonColor:
                                                                                    "#3085d6",
                                                                                cancelButtonColor:
                                                                                    "#d33",
                                                                            }
                                                                        ).then(
                                                                            (
                                                                                result
                                                                            ) => {
                                                                                if (
                                                                                    result.isConfirmed
                                                                                ) {
                                                                                    deletarFinanciamentoProduto(
                                                                                        f.ID_FINANCEIRO_EMPREENDIMENTO ??
                                                                                            0
                                                                                    ).then(
                                                                                        () => {
                                                                                            updateListFinanciamento();
                                                                                        }
                                                                                    );
                                                                                }
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    {deletarFinanciamentoProdutoLoading ? (
                                                                        <Spinner size="sm" />
                                                                    ) : (
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faTrash
                                                                            }
                                                                        />
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row">
                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_PERCENTUAL_ENTRADA`}
                                                                        label="Percentual de Entrada (%)"
                                                                        defaultValue={
                                                                            f.VL_PERCENTUAL_ENTRADA
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>
                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_QUANTIDADE_ENTRADA`}
                                                                        label="Quantidade de Entrada"
                                                                        defaultValue={
                                                                            f.VL_QUANTIDADE_ENTRADA
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_PERCENTUAL_MENSAL`}
                                                                        label="Percentual de Mensal (%)"
                                                                        defaultValue={
                                                                            f.VL_PERCENTUAL_MENSAL
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>
                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_QUANTIDADE_MENSAL`}
                                                                        label="Quantidade de Mensal"
                                                                        defaultValue={
                                                                            f.VL_QUANTIDADE_MENSAL
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>

                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_TAXA_JUROS_MENSAL`}
                                                                        label="Taxa de Juros Mensal (%)"
                                                                        defaultValue={
                                                                            f.VL_TAXA_JUROS_MENSAL
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_TAXA_JUROS_ANUAL`}
                                                                        label="Taxa de Juros Anual (%)"
                                                                        defaultValue={
                                                                            f.VL_TAXA_JUROS_ANUAL
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>
                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_PERCENTUAL_ANUAL`}
                                                                        label="Percentual de Anuais (%)"
                                                                        defaultValue={
                                                                            f.VL_PERCENTUAL_ANUAL
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>
                                                                <div className="form-group col-3">
                                                                    <UnForm.Input
                                                                        type="number"
                                                                        name={`VL_QUANTIDADE_ANUAL`}
                                                                        label="Quantidade de Anual"
                                                                        defaultValue={
                                                                            f.VL_QUANTIDADE_ANUAL
                                                                        }
                                                                        readOnly
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </OrSpinner>

                                            {lstFinanciamento?.length === 0 && (
                                                <div className="text-center py-5">
                                                    <p className="text-muted">
                                                        Nenhum financiamento
                                                        cadastrado
                                                    </p>
                                                </div>
                                            )}
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="vendas"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.LazySelect
                                                        name="ID_SITUACAO_COMERCIAL"
                                                        label="Situação Comercial"
                                                        controller={
                                                            ListarSituacaoComercialController
                                                        }
                                                        getDS={(s) =>
                                                            s.DS_SITUACAO_COMERCIAL
                                                        }
                                                        getKeyValue={(s) =>
                                                            s.ID_SITUACAO_COMERCIAL
                                                        }
                                                        defaultValue={
                                                            emp
                                                                ?.CONFIGURACAO_VENDAS
                                                                .ID_SITUACAO_COMERCIAL
                                                        }
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.LazySelect
                                                        name="ID_SITUACAO_OBRA"
                                                        label="Situação Obra"
                                                        controller={
                                                            ListarSituacaoObraController
                                                        }
                                                        getDS={(s) =>
                                                            s.DS_SITUACAO_OBRA
                                                        }
                                                        getKeyValue={(s) =>
                                                            s.ID_SITUACAO_OBRA
                                                        }
                                                        defaultValue={
                                                            emp
                                                                ?.CONFIGURACAO_VENDAS
                                                                .ID_SITUACAO_OBRA
                                                        }
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_ANDAMENTO_OBRA"
                                                        label="% de Andamento Obra"
                                                        defaultValue={
                                                            emp
                                                                ?.CONFIGURACAO_VENDAS
                                                                .VL_PERCENT_ANDAMENTO_OBRA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="number"
                                                        name="NR_RESERVA_HORAS"
                                                        label="Reserva (Horas)"
                                                        defaultValue={
                                                            emp
                                                                ?.CONFIGURACAO_VENDAS
                                                                .DT_RESERVA_HORAS
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_INICIO_BONIFICACAO"
                                                        label="Início da Bonificação"
                                                        defaultValue={emp?.CONFIGURACAO_VENDAS.DT_INICIO_BONIFICACAO?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="date"
                                                        name="DT_FIM_BONIFICACAO"
                                                        label="Fim da Bonificação"
                                                        defaultValue={emp?.CONFIGURACAO_VENDAS.DT_FIM_BONIFICACAO?.substring(
                                                            0,
                                                            10
                                                        )}
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_BONIFICACAO"
                                                        label="Bonificação"
                                                        defaultValue={
                                                            emp
                                                                ?.CONFIGURACAO_VENDAS
                                                                .DS_BONIFICACAO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.LazySelect
                                                        controller={
                                                            listarJornadaEtapa
                                                        }
                                                        getDS={(j) =>
                                                            j.DS_ETAPA_JORNADA
                                                        }
                                                        getKeyValue={(j) =>
                                                            j.ID_ETAPA_JORNADA
                                                        }
                                                        defaultValue={
                                                            props.row
                                                                ?.ID_ETAPA_JORNADA
                                                        }
                                                        name="ID_ETAPA_JORNADA"
                                                        label="Etapa da Jornada"
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="vistoria"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Switch
                                                        color="success"
                                                        label="Vistoria Antecipada"
                                                        name="FL_VISTORIA_ANTECIPADA"
                                                        type="checkbox"
                                                        labelPosition="top"
                                                        defaultChecked={
                                                            props.row
                                                                ?.DADOS_ADICIONAIS
                                                                ?.FL_VISTORIA_ANTECIPADA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Switch
                                                        color="success"
                                                        label="Produto Ativo Vistoria"
                                                        labelPosition="top"
                                                        name="FL_PRODUTO_ATIVO_VISTORIA"
                                                        type="checkbox"
                                                        defaultChecked={
                                                            emp
                                                                ?.QUALIFICACAO_EMPREENDIMENTO
                                                                .FL_PRODUTO_ATIVO_VISTORIA
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="tab-pane"
                                            id="integracao"
                                            role="tabpanel"
                                        >
                                            <div className="row">
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="ID_CHAVE_ERP_EMPRESA"
                                                        label="Chave ERP Empresa"
                                                        defaultValue={
                                                            emp
                                                                ?.DADOS_INTEGRACAO
                                                                .ID_CHAVE_ERP_EMPRESA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="ID_CHAVE_ERP_OBRA"
                                                        label="Chave ERP Obra"
                                                        defaultValue={
                                                            emp
                                                                ?.DADOS_INTEGRACAO
                                                                .ID_CHAVE_ERP_OBRA
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="ID_CHAVE_ERP_PRODUTO"
                                                        label="Chave ERP Produto"
                                                        defaultValue={
                                                            emp
                                                                ?.DADOS_INTEGRACAO
                                                                .ID_CHAVE_ERP_PRODUTO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="ID_CHAVE_ERP_CONTRATO"
                                                        label="Chave ERP Contrato"
                                                        defaultValue={
                                                            emp
                                                                ?.DADOS_INTEGRACAO
                                                                .ID_CHAVE_ERP_CONTRATO
                                                        }
                                                    />
                                                </div>
                                                <div className="form-group col-3">
                                                    <UnForm.Input
                                                        type="text"
                                                        name="DS_TAG_IMPORTACAO"
                                                        label="Tag de Importação"
                                                        defaultValue={
                                                            emp
                                                                ?.DADOS_INTEGRACAO
                                                                .DS_TAG_IMPORTACAO
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {props.row?.ID_EMPREENDIMENTO && (
                                            <>
                                                <div
                                                    className="tab-pane"
                                                    id="unidades"
                                                    role="tabpanel"
                                                >
                                                    <Table
                                                        keyField="DS_UNIDADE"
                                                        columns={
                                                            columnsUnidades
                                                        }
                                                        data={
                                                            emp?.UNIDADE_EMPREENDIMENTO ||
                                                            []
                                                        }
                                                        loading={empLoading}
                                                        sizePerPage={10}
                                                        noSearch
                                                        noDataIndication={
                                                            <div className="text-center">
                                                                <p>
                                                                    Nenhuma
                                                                    unidade
                                                                    encontrada
                                                                </p>
                                                            </div>
                                                        }
                                                        onTableChange={(
                                                            type,
                                                            newState
                                                        ) => {
                                                            setPageUnidadesEmp(
                                                                newState.page
                                                            );
                                                        }}
                                                        page={pageUnidadesEmp}
                                                    />
                                                </div>

                                                <div
                                                    className="tab-pane"
                                                    id="documentos"
                                                    role="tabpanel"
                                                >
                                                    {InserirDocumentosPorProdutoLoading && (
                                                        <div>
                                                            <p className="text-center">
                                                                Salvando{" "}
                                                                {
                                                                    completedUploads
                                                                }{" "}
                                                                de{" "}
                                                                {
                                                                    documents.length
                                                                }{" "}
                                                                documentos
                                                                <span className="dots-loading"></span>
                                                            </p>
                                                        </div>
                                                    )}
                                                    <div className="d-flex justify-content-end">
                                                        {documents &&
                                                            documents.length >
                                                                0 && (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip id="salvar-documentos-tooltip">
                                                                            Salvar
                                                                            Documentos
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <button
                                                                        className="btn btn-success"
                                                                        type="button"
                                                                        onClick={
                                                                            handleFileUpload
                                                                        }
                                                                        disabled={
                                                                            InserirDocumentosPorProdutoLoading
                                                                        }
                                                                    >
                                                                        {InserirDocumentosPorProdutoLoading ? (
                                                                            <Spinner size="sm" />
                                                                        ) : (
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faSave
                                                                                }
                                                                            />
                                                                        )}
                                                                    </button>
                                                                </OverlayTrigger>
                                                            )}
                                                    </div>

                                                    <hr />
                                                    <div className="mb-3">
                                                        <div
                                                            className={`w-100 py-10 mb-4 text-center`}
                                                            style={{
                                                                borderStyle:
                                                                    "dotted",
                                                                borderColor:
                                                                    "#d3d3d3",
                                                                borderRadius:
                                                                    "5px",
                                                            }}
                                                            onDragOver={
                                                                handleDragOver
                                                            }
                                                            onDragLeave={
                                                                handleDragLeave
                                                            }
                                                            onDrop={handleDrop}
                                                        >
                                                            Arraste e solte o
                                                            arquivo aqui ou
                                                            Selecione Abaixo
                                                        </div>
                                                        <input
                                                            className="mb-3"
                                                            type="file"
                                                            onChange={
                                                                handleFileSelect
                                                            }
                                                            multiple
                                                            ref={fileInputRef}
                                                        />
                                                        {documents &&
                                                            documents.length >
                                                                0 && (
                                                                <Table
                                                                    keyField="ID_DOCUMENTO_PRODUTO"
                                                                    data={
                                                                        documents
                                                                    }
                                                                    columns={
                                                                        columnsDocsAdicionados
                                                                    }
                                                                    bordered={
                                                                        true
                                                                    }
                                                                    hover
                                                                    condensed
                                                                    noSearch
                                                                    onTableChange={(
                                                                        type,
                                                                        newState
                                                                    ) => {
                                                                        setPageDocumentosEmp(
                                                                            newState.page
                                                                        );
                                                                    }}
                                                                    page={
                                                                        pageDocumentosEmp
                                                                    }
                                                                />
                                                            )}

                                                        <div className="d-flex justify-content-end flex-column align-items-end">
                                                            <span className="my-2">
                                                                Ao marcar uma
                                                                imagem como
                                                                destaque, apenas
                                                                ela será
                                                                considerada como
                                                                destaque do
                                                                produto.
                                                            </span>
                                                            <span className="my-2">
                                                                Ao marcar uma
                                                                imagem como
                                                                implantação,
                                                                apenas ela será
                                                                visível no
                                                                painel de
                                                                implantação.
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <hr />
                                                    <Table
                                                        key={`${lstDocumentosLoading}-${RemoverDocumentosPorProdutoLoading}`}
                                                        keyField="ID_DOCUMENTO_PRODUTO"
                                                        columns={
                                                            columnsDocumentos
                                                        }
                                                        data={
                                                            lstDocumentos || []
                                                        }
                                                        loading={
                                                            lstDocumentosLoading
                                                        }
                                                        sizePerPage={10}
                                                        noDataIndication={
                                                            <div className="text-center">
                                                                <p>
                                                                    Nenhum
                                                                    documento
                                                                    encontrado
                                                                </p>
                                                            </div>
                                                        }
                                                        noSearch
                                                    />
                                                </div>

                                                <div
                                                    className="tab-pane"
                                                    id="alteracoes"
                                                    role="tabpanel"
                                                >
                                                    <Table
                                                        keyField="DS_PRODUTO_LOG"
                                                        columns={
                                                            columnsAlteracoes
                                                        }
                                                        data={
                                                            emp?.ALTERACOES_PRODUTO ||
                                                            []
                                                        }
                                                        loading={empLoading}
                                                        sizePerPage={10}
                                                        noSearch
                                                        noDataIndication={
                                                            <div className="text-center">
                                                                <p>
                                                                    Nenhuma
                                                                    alteração
                                                                    encontrada
                                                                </p>
                                                            </div>
                                                        }
                                                        onTableChange={(
                                                            type,
                                                            newState
                                                        ) => {
                                                            setPageAlteracoes(
                                                                newState.page
                                                            );
                                                        }}
                                                        page={pageAlteracoes}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-center align-items-center mt-6">
                                <UnForm.SubmitButton
                                    id="dados_form_submit_button"
                                    color={
                                        props.editando ? "primary" : "success"
                                    }
                                    iconSize="lg"
                                    loading={isLoading}
                                    wrapperClassName="d-flex justify-content-center align-items-center col-12"
                                    loadingSize="sm"
                                    className="font-weight-bold col-3"
                                    icon={props.editando ? faEdit : faBuilding}
                                >
                                    {props.editando
                                        ? "Editar Produto"
                                        : "Cadastrar Produto"}
                                </UnForm.SubmitButton>
                            </div>
                        </div>
                    </div>
                </UnForm>
            </FormProvider>{" "}
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </>
    );
}
